import React from "react";
import { FarmerImageStyled } from "./FarmerImageStyled";
var FarmerImage = function (_a) {
    var logoImg = _a.logoImg;
    return (React.createElement(FarmerImageStyled, { logoImg: logoImg, className: "farmer-image" }));
};
export default FarmerImage;
//# sourceMappingURL=FarmerImage.js.map